<template>
  <div id="app">
    <!--头部-->
    <Top :selected="sendSelected" ></Top>
    <router-view v-on:nav="Nav" ></router-view>
    <!--底部-->
    <Bottom :colour="colourClass"></Bottom>
    <!--返回顶部-->
    <BackHead></BackHead>

  </div>
</template>

<script>
import Top from '@/components/public/top'
import Bottom from '@/components/public/footer'
import BackHead from '@/components/public/BackHead'
export default {
  name: 'app',
  data () {
    return {
      sendSelected:'',
      colourClass:'',
    }
  },
  components:{
    Top,
    Bottom,
    BackHead,
  },
  watch:{
    '$route':function(to,from){
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0; 
    }
  },
  methods:{
    Nav: function(msg,msg2){
      this.sendSelected = msg;
      this.colourClass = msg2;
    },
  }
  
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue